import React from "react";

import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import TreeSearch from "./TreeSearch";
import SmartTabs from "./../tabs/SmartTabs";

import { IoQrCode } from "react-icons/io5";
//import illu_search from "../../assets/illustrations/onboarding/illustration_remotesearch.svg";

import "./SearchStyle.css";

const Search = ({ serverData }) => {
  let navigate = useNavigate();

  /**
   * Method to navigate to the qr search section.
   */
  const goToQRsearch = () => {
    navigate("/search/qr");
  };

  /**
   * Method to calculate the sum of total rooms.
   * @returns Total sum or a "-" as fallback.
   */
  const calcTotalRooms = () => {
    if (serverData.allRoomIDs && serverData.allRoomIDs !== null) {
      return serverData.allRoomIDs.length;
    } else return "-";
  };

  /**
   * Method to calculate the sum of total buildings.
   * @returns Total sum or a "-" as fallback.
   */
  const calcTotalBuildings = () => {
    if (serverData.allRoomBuildings && serverData.allRoomBuildings !== null)
      return serverData.allRoomBuildings.length;
    else return "-";
  };

  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.3,
        },
      }}
    >
      <div className="search-content">
        <h1 className="main-headline">
          <span className="text-gradient-primary">Hörsaalsuche</span>
        </h1>

        <div className="search-button-container">
          <TreeSearch
            roomsForFiltering={
              serverData.roomsForFiltering ? serverData.roomsForFiltering : []
            }
          />

          <button className="qr-search-button" onClick={goToQRsearch}>
            <IoQrCode />
            <span>QR-Härsaalcode scannen</span>
          </button>
        </div>

        <div className="stats-container">
          <p className="stats-description">Aktuelle Statistik:</p>
          <div className="stats-item-wrapper">
            <div className="stats-item">
              <p className="stats-headline">Räume</p>
              <p>{calcTotalRooms()}</p>
            </div>
            <div className="stats-item">
              <p className="stats-headline">Gebäude</p>
              <p>{calcTotalBuildings()}</p>
            </div>
          </div>
        </div>

        <div className="link-onboarding-container">
          <Link to={"/onboarding"}>Link zur "Onboarding"-Seite</Link>
        </div>

        {/* Illustration is hidden for design purposes. */}
        {/*
        <div className="illustration-container">
          <img src={illu_search} alt="illustration" />
        </div>
        */}
      </div>

      <SmartTabs
        allRooms={serverData.allRooms ? serverData.allRooms : []}
        troubleReportData={
          serverData.troubleReports ? serverData.troubleReports : []
        }
      />
    </motion.div>
  );
};

export default Search;
